import { normalize } from 'normalizr';
import { put } from 'redux-saga/effects';

// actions
import { errorIndicator,
         load,
         success,
         successIndicator } from '../actions/standardActions';

export default function* (type, request, schema) {
  yield put(load(type));

  try {
    const response = yield request;

    yield put(successIndicator(type));

    const payload = response.body;

    if (schema) {
      const normalizedData = normalize(response.body.items || response.body, schema);

      payload.normalized = normalizedData;
    }

    yield put(success(type, payload));
    console.log(response)
    return response;
  } catch (err) {
    yield put(errorIndicator(type));

    throw err;
  }
}



// WEBPACK FOOTER //
// ./app/lib/httpSaga.js